export default __webpack_public_path__ + "static/media/Play.aaf1c04b.svg";